import React, {useState, useEffect} from 'react';
import {useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import axios from "axios";

const PurchaseorderShowComponent = (props) => {

  const {t} = props;
  const {action, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [statusDictionary, setStatusDictionary] = useState([]);
  const [nextStatuses, setNextStatuses] = useState([]);

  // const poStatus = formData?.status || '';
  // const canEditPo = ['NEW', 'IN_PROGRESS'].includes(poStatus.toUpperCase());

  const labelForStatus = (key) => {
    if (!key) return '';
    const hit = statusDictionary.find(s => String(s.key).toUpperCase() === String(key).toUpperCase());
    return hit?.value || key;
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const getNextStatuses = (current) => {
    const normalized = (current || '').toUpperCase();
    const map = {
      NEW: ['IN_PROGRESS', 'DELETED'],
      IN_PROGRESS: ['CLOSED', 'DELETED'],
      // COMPOSED: ['ORDERED'],
      // ORDERED: ['CLOSED'],
      // RECEIVING: ['CLOSED'],
      DELETED: [],
      CLOSED: [],
    };
    const keys = map[normalized] || [];
    return keys
      .map(k => statusDictionary.find(s => String(s.key).toUpperCase() === k))
      .filter(Boolean);
  };

  // const handleStatusChange = (statusKey) => {
  //   setLoading(true);
  //   apiCall('patch', `/api/v2/purchase-order/${id}`, { status: statusKey })
  //     .then((response) => {
  //       setFormData(response.data.data);
  //       window.App.toastShow('success', 'Sikeres státusz módosítás!');
  //       window.App.setState({
  //         rerenderPurchaseorderList: Math.random(),
  //         rerenderPurchaseorderShow: Math.random()
  //       });
  //     })
  //     .catch((error) => {
  //       window.App.toastShow('error', t('error'), error.toString(), '', error.response);
  //     })
  //     .finally(() => setLoading(false));
  // };

  useEffect(() => {
    if (id && action === 'read') {
      setLoading(true);
      apiCall('get', '/api/v2/purchase-order/' + id)
        .then(response => {
          setFormData(response.data.data)
          props.onLoaded(response.data.data || {});
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [window.App.state.rerenderPurchaseorderShow, id])

  useEffect(() => {
    apiCall('GET', '/api/v2/dictionary/purchase-order-status')
      .then(res => {
        const raw = res.data?.data;
        setStatusDictionary(Array.isArray(raw) ? raw : (raw?.items || []));
      })
      .catch(err => {
        window.App.toastShow('error', t('error'), err.toString(), '', err.response);
      });
  }, []);


  
  useEffect(() => {
    if (formData?.status && statusDictionary.length > 0) {
      setNextStatuses(getNextStatuses(formData.status));
    }
  }, [formData.status, statusDictionary]);

  useEffect(() => {
    if (props.purchaseorder) {
      setFormData(props.purchaseorder);
    }
  }, [props.purchaseorder]);

  return (
    <div className={"purchaseorder-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="location">{t('columnPurchaseOrderNumber')}</label>
            <span className="p-d-block fake-input">
              {formData?.purchase_order_number}
            </span>
          </div>
        </div>
        {/* <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="location">{t('columnLocation')}</label>
            <span className="p-d-block fake-input">
              {formData?.location?.name}
            </span>
          </div>
        </div> */}
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="location">{t('columnProject')}</label>
            <span className="p-d-block fake-input">
              {formData?.project?.name}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="location">{t('columnWarehouse')}</label>
            <span className="p-d-block fake-input">
              {formData?.warehouse?.name}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="created_by_name">{t('columnContactPerson')}</label>
            <span className="p-d-block fake-input">
              {formData.created_by?.name}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="last_name">{t('columnStatus2')}</label>
            <span className="p-d-block fake-input">
              {labelForStatus(formData?.status)}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="created_at">{t('columnCreatedAt')}</label>
            <span className="p-d-block fake-input">
              {window.App.formatDateValue(formData.created_at)}
            </span>
          </div>
        </div>
        {/*<div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="created_at">{t('columnDeadline')}</label>
            <span className="p-d-block fake-input">
              {window.App.formatDateValue(formData.expected_delivery_date)}
            </span>
          </div>
        </div>*/}
      </div>


    </div>
  )
}
export default withTranslation('common')(PurchaseorderShowComponent);
